import { SortOrder } from '@common/utils/search-sort';

export enum AvailableTabsOnPage {
  List = 'list',
  Groups = 'groups',
}

export interface ListTabPageState {
  searchValue: string;
  sortOrder: SortOrder;
  loading?: boolean;
}

export type GroupsTabPageState = ListTabPageState & {
  openedGroupId: number | null;
  isOpenedFreeList: boolean;
  loading?: boolean;
};

export interface LastPageStateWithTabs {
  activeTabOnPage: AvailableTabsOnPage;
  [AvailableTabsOnPage.List]: ListTabPageState;
  [AvailableTabsOnPage.Groups]: GroupsTabPageState;
}
